// extracted by mini-css-extract-plugin
module.exports = {"user-menu":"UserMenu_user-menu__Nci0v","user":"UserMenu_user__VVlOZ","hamburger":"UserMenu_hamburger__q1YdK","howItWorks":"UserMenu_howItWorks__4_4td"};